import { createSelector } from "reselect"
import {State} from "./reducers"

export const mif = (state: State) => state.mif;
export const erdr = (state: State) => state.erdr;
export const general = (state: State) => state.general;
export const runoffView = (state: State) => state.runoffView;
export const equityInjections = (state: State) => state.equityInjections;
export const specialRules = (state: State) => state.specialRules;